module.exports = __webpack_public_path__ + "static/media/img-background1.0838971a.jpg";